import { HttpInterceptorFn } from '@angular/common/http';

const CORRELATION_ID_HEADER = 'X-Correlation-Id';

function generateCorrelationId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID (older browsers/test runners).
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export const correlationIdInterceptor: HttpInterceptorFn = (req, next) => {
  if (/^https?:\/\//i.test(req.url) || req.headers.has(CORRELATION_ID_HEADER)) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { [CORRELATION_ID_HEADER]: generateCorrelationId() },
    }),
  );
};
